"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeInput = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = require("react-dom");
const clsx_1 = __importDefault(require("clsx"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const ArrowDropDown_1 = __importDefault(require("@material-ui/icons/ArrowDropDown"));
const text_field_1 = require("../text-field/text-field");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const tree_context_1 = require("./tree-context");
const tree_styles_1 = require("./tree-styles");
function TreeInput({ popupOpen, setPopupOpen, textValue, setTextValue, setSearchQuery, anchorElRef, inputRef, }) {
    const classes = (0, tree_styles_1.useStyles)();
    const { source, disabled, form } = (0, react_1.useContext)(tree_context_1.TreeContext);
    const handleChange = (0, event_callback_hook_1.useEventCallback)((value) => {
        setTextValue(value !== null && value !== void 0 ? value : '');
        setSearchQuery(value);
    });
    const handleClick = (0, event_callback_hook_1.useEventCallback)(() => {
        if (!disabled) {
            (0, react_dom_1.unstable_batchedUpdates)(() => {
                source.reset();
                source.setSearchQuery(textValue !== null && textValue !== void 0 ? textValue : '');
                source.loadMore();
            });
            setPopupOpen(true);
        }
    });
    return (react_1.default.createElement("div", { className: classes.input, onClick: handleClick, ref: anchorElRef },
        react_1.default.createElement(text_field_1.TextField, { ref: inputRef, form: form, showClearButton: false, endAdornment: react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(IconButton_1.default, { size: "small", classes: {
                        root: (0, clsx_1.default)(classes.icon, {
                            [classes.iconOpened]: popupOpen,
                        }),
                    } },
                    react_1.default.createElement(ArrowDropDown_1.default, { fontSize: "small" }))), value: textValue, onChange: handleChange })));
}
exports.TreeInput = TreeInput;
//# sourceMappingURL=tree-input.js.map